// src/utils/knowYourNumbersStore.js
// Read/write the user's Know Your Numbers answers. They live as a nested
// `knowYourNumbers` map on the existing scorecards/{uid} doc (one coaching doc
// per user; the catch-all authed rule already covers it — no rules change).
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { firestored } from "../firebase/firebaseConfig";

export const KYN_FALLBACK = {
  perFileCosts: "",
  hoursPerWeek: "",
  weeksWorkedYtd: "",
  tasksBelowWage: [
    { task: "", hrs: "", owner: "" },
    { task: "", hrs: "", owner: "" },
    { task: "", hrs: "", owner: "" },
  ],
  staffingChoice: "",
  staffingAdjustment: "",
  staffingBy: "",
  goalDate: "",
  seatsToday: "",
  goals: {
    income: "",
    volume: "",
    closings: "",
    leadsPerMonth: "",
    hoursPerWeek: "",
    teamSeats: "",
  },
  biggestGaps: ["", "", ""],
  moves: [
    { move: "", weeklyNum: "", starts: "" },
    { move: "", weeklyNum: "", starts: "" },
    { move: "", weeklyNum: "", starts: "" },
  ],
  // Typed-over auto numbers, kept per scope so a corrected number stays
  // corrected. A missing key means "use the live auto value".
  overridesMe: {},
  overridesTeam: {},
  lastScope: "me",
};

const refFor = (uid) => doc(firestored, "scorecards", uid);

const threeOf = (list, blank) => {
  const src = Array.isArray(list) ? list : [];
  return [0, 1, 2].map((i) => ({ ...blank, ...(src[i] || {}) }));
};

export async function loadKnowYourNumbers(uid) {
  if (!uid) return { ...KYN_FALLBACK };
  try {
    const snap = await getDoc(refFor(uid));
    const saved = snap.exists() ? snap.data()?.knowYourNumbers || {} : {};
    return {
      ...KYN_FALLBACK,
      ...saved,
      goals: { ...KYN_FALLBACK.goals, ...(saved.goals || {}) },
      tasksBelowWage: threeOf(saved.tasksBelowWage, { task: "", hrs: "", owner: "" }),
      biggestGaps: [0, 1, 2].map((i) => (saved.biggestGaps || [])[i] || ""),
      moves: threeOf(saved.moves, { move: "", weeklyNum: "", starts: "" }),
      overridesMe: { ...(saved.overridesMe || {}) },
      overridesTeam: { ...(saved.overridesTeam || {}) },
    };
  } catch (err) {
    console.error("loadKnowYourNumbers failed:", err);
    return { ...KYN_FALLBACK };
  }
}

export async function saveKnowYourNumbers(uid, values) {
  if (!uid) return;
  await setDoc(
    refFor(uid),
    { knowYourNumbers: { ...values }, updatedAt: serverTimestamp() },
    { merge: true },
  );
}
